import React from 'react';
import { useTranslation } from 'react-i18next';

import FullscreenFormModal from '../../components/FormModal/FullscreenFormModal';
import { GroupWithInvited } from '../types';

type GroupFormModalProps = {
  /** Slug du formulaire (config `formSlug`) */
  formSlug: string;
  /** Identifiant du user courant, passé au formulaire en création (`parentId`) */
  userId: string;
  /** Groupe à éditer. Si absent, le formulaire est en mode création. */
  group?: GroupWithInvited;
  onClose: () => void;
};

const GroupFormModal = ({ formSlug, userId, group, onClose }: GroupFormModalProps): JSX.Element => {
  const { t } = useTranslation();
  const title = group ? t('group-visits.modal.edit-title') : t('group-visits.modal.create-title');

  return (
    <FullscreenFormModal
      formSlug={formSlug}
      title={title}
      // Édition : `/k/{privateKey}` ; création : `?parentId={userId}`
      privateKey={group?.privateKey}
      query={group ? undefined : { parentId: userId }}
      onClose={onClose}
    />
  );
};

GroupFormModal.defaultProps = {
  group: undefined,
};

export default GroupFormModal;
